import { Field, Form, Formik } from 'formik';
import { useMutation, useQuery } from 'react-query';
import { AddAnswerList, ChangeRequestStatus, GetAllForms, GetDataOfRequest, GetRequestId } from './ApRequests';
import Loading from '../../SharedComponents/Loading';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingCircle from '../../SharedComponents/Svg/LoadingCircle';
import Notification from '../../SharedComponents/Notification';
import { useHistory, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import NewNotification from '../../SharedComponents/NewNotification';

export default function FormContainer(props) {
  const [val, setVal] = useState({});
  const { t } = useTranslation();
  const [languageId, setLanguageId] = useState(1);
  const { formID, requestStatus } = props;
  const history = useHistory();
  const [req, setReq] = useState();
  const params = useParams();
  const { requestId } = params;

  const ChangeRequestStatusMutation = useMutation(ChangeRequestStatus, {
    onSuccess: (data) => {
      history.push(`/request/${requestStatus + 1}/${requestId ? requestId : req}`);
    },
  });
  const getRequestIdMutation = useMutation(GetRequestId, {
    onSuccess: (data) => {
      setReq(data.data.outId);
      addAnswerList(data.data.outId);
      toast.custom(<Notification message={t('Request Created Successfully')} />);
    },
  });
  const addAnswerListMutation = useMutation(AddAnswerList, {
    onSuccess: (data) => {
      toast.custom(<Notification message={t('Data Saved, Successfully')} />);
      // ChangeRequestStatusMutation
      ChangeRequestStatusMutation.mutate({
        id: requestId ? requestId : req,
        requestStatus: 1,
      });
    },
  });

  const inputs = {
    1: 'text',
    2: 'radio',
    3: 'checkbox',
    4: 'file',
    5: 'tel',
    6: 'url',
    7: 'number',
    8: 'select',
    9: 'textarea',
  };

  const body = {
    formId: formID,
  };

  const { data, isLoading, isError } = useQuery(['GetAllForms', body], GetAllForms);
  // useEffect(() => {}, [isEdit]);
  if (isLoading)
    return (
      <div
        className="relative bg-white"
        style={{
          minHeight: '500px',
        }}
      >
        <Loading />
      </div>
    );
  if (isError) return 'error';

  const getInitialValues = () => {
    const arrayOfKeys = data.data.map((item) => item.inputName);
    const object = {};

    for (let index = 0; index < arrayOfKeys.length; index++) {
      const key = arrayOfKeys[index];
      object[key] = '';
    }
    return object;
  };
  const getDateHandler = (date, time) => {
    const day = date ? new Date(date) : new Date();
    return `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()}`;
  };

  const initialValues = getInitialValues();
  // const initialValuesv2 = getInitialValuesWithData();
  console.log('initialValuesv2', initialValues);
  const addAnswerList = (outId) => {
    const userData = localStorage.getItem('token');
    const userId = userData ? JSON.parse(userData).userId : 0;
    const entries = Object.entries(val);
    const newArr = entries?.map((e) => e);
    const newData = newArr.map((x, index) => {
      const questionId = data.data.find((e) => e.inputName === `${x[0]}`).id;
      let l = {
        questionId: questionId,
        answer: x[1],
        userId: userId,
        formId: formID,
        creationDateString: getDateHandler(),
        createDate: new Date(),
        RequestDataId: outId,
        requestData: {
          requestStatus: 1,
        },
      };
      return l;
    });
    console.log(newData, 'newData');
    addAnswerListMutation.mutate(newData);
  };

  const SubmitHandler = (values) => {
    setVal(values);
    console.log('requestId', requestId);
    if (requestId) {
      console.log('we have request ID ');
      addAnswerList(requestId);
    } else {
      setTimeout(() => {
        console.log('NO  request ID ');
        getRequestIdMutation.mutate();
      }, 100);
    }
    // setTimeout(() => {
    //   if (requestId) {
    //   } else {
    //     console.log('xx', requestId);
    //   }
    // }, 100);
  };
  return (
    <>
      {/* {addAnswerListMutation.isSuccess && <Notification message={t('Request Created Successfully')} />} */}

      <Formik initialValues={initialValues} onSubmit={SubmitHandler}>
        {({ values, setFieldValue }) => (
          <Form className="flex flex-col   relative   px-6 py-6 text-gray-600 font-bold  ">
            {data.data.map((item, index) => {
              if (inputs[item.qtypeId] === 'textarea') {
                return (
                  <label key={index} className={`flex  flex-col mb-8 justify-start space-y-2`}>
                    <span>{item.frmQuestionLngs.filter((item) => item.languageId === languageId)[0]?.title}</span>
                    <Field
                      name={item?.inputName}
                      value={values[item?.inputName]}
                      className="border rounded py-2 px-3"
                      type={inputs[item.qtypeId]}
                      as="textarea"
                      onChange={(e) => {
                        setFieldValue(item?.inputName, e.target.value);
                      }}
                    />
                  </label>
                );
              }
              return (
                <label key={index} className={`flex  flex-col mb-8 justify-start space-y-2`}>
                  <span>{item.frmQuestionLngs.filter((item) => item.languageId === languageId)[0]?.title}</span>
                  <Field
                    name={item?.inputName}
                    value={values[item?.inputName]}
                    className="border rounded py-2 px-3"
                    type={inputs[item.qtypeId]}
                    checked={values[item?.inputName]}
                    onChange={(e) => {
                      if (inputs[item.qtypeId] === 'checkbox') {
                        setFieldValue(item?.inputName, Boolean(!values[item?.inputName]));
                      } else {
                        setFieldValue(item?.inputName, e.target.value);
                      }
                    }}
                  />
                </label>
              );
            })}
            <button
              type="submit"
              className="bg-darkblue w-24 flex justify-center items-center hover:bg-darkbluehover text-white px-4 py-2 rounded"
            >
              {t('Save')}
              {addAnswerListMutation.isLoading || (getRequestIdMutation.isLoading && <LoadingCircle />)}
            </button>
          </Form>
        )}
      </Formik>
    </>
  );
}
